import React, {useContext, useMemo, memo} from 'react';
import './bids-and-buynow-block.css';
import Helper from '../../../helpers/global-helper'
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import {LotsContext} from "../../auction-lots-listing/auction-lots-listing";
import {includes} from "lodash/collection";
import {lotContext} from "../../auction-lots-listing/components/lots-list-item/lots-list-item";

const BidAndBuyNowBlock = memo(() => {
    const {lotData} = useContext(lotContext);
    const {min_bid, top_bid, buyout_price, status, amount} = lotData
    const {phrases: {ak_au_buyout_price, price, ak_count_bid}, type, user_lots_type} = useContext(LotsContext);

    return useMemo(() => {
        if (type === 'all_user_bets') {
            return (
                <div className="my-1 d-flex">
                    <span className="">{ak_count_bid}:</span>
                    <OverlayTrigger
                        placement={'bottom'}
                        overlay={
                            <Tooltip id="count_bid">
                                {ak_count_bid}
                            </Tooltip>
                        }>
                        <span className="new ms-xl-auto mx-1">{Helper.currencyFormat(amount)}</span>
                    </OverlayTrigger>
                </div>
            );
        }

        const cost = (top_bid === 0 || top_bid === null) ? min_bid : top_bid
        const statuses = ['active', 'no_pay', 'nosale', 'finalized', 'vacation', 'inactive_copy'];
        const priceCondition = includes(statuses, status);

        const buyoutPriceBlock = (buyout_price > 0 && priceCondition && user_lots_type !== 'archive_lots') ?
            <div className="my-1 d-flex">
                <span className="">{ak_au_buyout_price}:</span>
                <span className="new ms-xl-auto text-danger mx-1">
                {Helper.currencyFormat(buyout_price)}
            </span>
            </div> : null;


        if (cost == buyout_price && priceCondition) {
            return (<>{buyoutPriceBlock}</>);
        }

        return (
            <>
                <div className="my-1 d-flex">
                    {(priceCondition) ? <span className="">{price}:</span> : null}
                    <span className="new ms-xl-auto mx-1">{Helper.currencyFormat(cost)}</span>
                </div>
                {buyoutPriceBlock}
            </>
        )

    }, [type, amount, buyout_price, top_bid, min_bid, status, user_lots_type, ak_count_bid, ak_au_buyout_price, price])
});

export default BidAndBuyNowBlock;